import React from 'react';
import styled from 'styled-components';
import { Spotlight } from 'api/spotlight/types';
import { Avatar } from 'components/atoms/avatar';
import { SpotlightMessageInverse20 } from 'components/atoms/icons/spotlight-message-inverse';
import { useGetUserByUserId } from 'hooks/use-idb';
import { fullName } from 'utils/full-name';

interface Props {
  spotlight: Spotlight;
}

const Wrapper = styled.div`
  width: 100%;
  padding: var(--spacing-05);
  background: #f7ae58;
  border-radius: var(--border-radius-small);
  display: flex;
  align-items: center;
  justify-content: start;
  position: relative;
  align-items: flex-start;
  justify-content: start;
  position: relative;
  gap: var(--spacing-03);
  > svg {
    flex-shrink: 0;
  }
`;

const Content = styled.div``;

export const SpotlightForTaskDrawer: React.FC<Props> = ({ spotlight }) => {
  const user = useGetUserByUserId(spotlight?.createdBy);

  return (
    <Wrapper>
      <SpotlightMessageInverse20 />
      {user ? (
        <Avatar size="small" src={user?.photoUrl} name={fullName(user)} />
      ) : (
        <></>
      )}
      <Content>{spotlight.caption}</Content>
    </Wrapper>
  );
};
